<mat-dialog-content>
  <!-- IA Table -->
  <div *ngIf="isIAWorkOrderStatus()">
    <h3>Work Order Status</h3>
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>S.No</th>
          <th>Proposal Id</th>
          <th class="d-none">Proposal Id</th>
          <th>Days Remaining</th>
          <th>Reminder Message</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data; let i = index">
          <td>{{ i + 1 }}</td> 
          <td>
            <a (click)="onViewProposal(item.proposalUserId, 'view')"
               *ngIf="item.createdProposalId"
               class="clickable-link">
              {{ item.createdProposalId }}
            </a>
          </td>
          <td class="d-none">{{ item.proposalUserId }}</td>
          <td>{{ item.daysRemaining }}</td>
          <td>{{ item.reminderMessage }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</mat-dialog-content>


<mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
